import LoginBlock from "../../components/LoginBlock";
import styles from "./loginpage.module.css";
import HexagonComponent from "../../components/HexagonComponent";
import HeaderPage from "../../components/HeaderPage";

export default function LoginPage() {
  return (
    <div className={`container-fluid h-custom ${styles.page}`}>
      <HeaderPage />
      <div className={`row my-5 ${styles.logoandloginBlock}`}>
        <div
          className={`col-lg-4 col-xl-4 col-md-6 col-sm-4 ${styles.hexagonlogoContainer}`}
        >
          <HexagonComponent />
        </div>
        <div
          className={`col-lg-4 col-xl-4 col-md-6 col-sm-3 ${styles.loginContainer}`}
        >
          <LoginBlock />
        </div>
      </div>
    </div>
  );
}
